import { api1C } from './api';

export const getInvoices = (params) => api1C.get('invoice', {params});

export const saveInvoice = (data, params) => api1C.post('invoice', data, {params});